/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-标签管理-二级标签
 */
'use strict';
angular.module("twoLevelLabelModule",["addOrEditTwoTagServiceModule"]).
controller('twoLevelLabelCtrl', ['$scope','$stateParams','httpService','addOrEditTwoTagService','modalDialog',function($scope,$stateParams,httpService,addOrEditTwoTagService,modalDialog){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
        $scope.data = {
            parentId: $stateParams.parentId,
            channelId:$stateParams.channelId,
            tagName :$stateParams.tagName,
            channelName:$stateParams.channelName,
            selectedArray:[]//选中的数据
        }
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0
        };
    };
    function initData(){
		requestData();
    };
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectTag = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
	 /**
     * [initStatus description] 初始化数据
     * 
     */
    $scope.requestData = function(){
		requestData();    	
    }
    
    function requestData(){
    	var params = {
      	  	parentId:$scope.data.parentId, 
      		currPage:$scope.page.CURRPAGE,
      		pageSize:$scope.page.PAGESIZE
        }
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/tag/secondTags.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        })
    }
    
    /**
     * [addOrEditTwoTag description] 添加二级标签
     * @return {[type]} [description]
     */
    $scope.addOrEditTwoTag = function(tagId,tagName){
    	var parentId = $scope.data.parentId;
    	var channelId = $scope.data.channelId;
    	addOrEditTwoTagService.addOrEditTwoTag(tagId,tagName,parentId,channelId).then(function(data) {
    		data.parentId = $scope.data.parentId;
    		data.channelId = $scope.data.channelId;
	    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/tag/addEditSecondTag.do", data, "post").then(function(data) {
	    		if(tagId==0){
	    			modalDialog.alertType('','新建标签成功','success');
	    		}else{
	    			modalDialog.alertType('','编辑标签成功','success');
	    		}
	    		requestData();
	        });
        });
    }
    
    /**
     * [addOrEditTag description] 删除标签
     * @return {[type]} [description]
     */
    $scope.deleteTags = function(id){
    	var txt = "";
    	var params = {
    		ids:''
    	};
    	if(id){
    		txt = "确认删除此标签";
    		params.ids = id ;
    	}else{
    		txt = "确认删除选中标签";
    		params.ids = angular.packageIds($scope.data.selectedArray,",","id") ;
    	}
    	modalDialog.backConfirmModal("删除", txt, function() {
	            httpService.http("/mcnadmin/admin/tag/deleteTag.do", params, "post").then(function(data) {
	            	modalDialog.alertType('','删除标签成功','success');
	                requestData();
	            });
	        });
    }
}]);